export function publishStatusPipe(pubYN: boolean): string {
    return pubYN ? "Đã xuất bản" : "Nháp";
}
